import styled, { css } from 'styled-components';

interface VerticalListContainerProps {
  isOpen?: boolean;
}

export const VerticalListContainer = styled.ul<VerticalListContainerProps>`
  width: 100%;
  max-height: 22rem;
  overflow-y: auto;
  background-color: #373245;
  position: absolute;
  z-index: 11;
  top: 46px;
  border-radius: 6px;
  ${({ isOpen }) => {
    return isOpen ? '' : 'display: none';
  }}
`;

export const VerticalListItem = styled.li`
  width: 100%;
  padding: 10px;
  background-color: #373245;
  border-radius: 6px;

  &.selected {
    background: #fff;
    color: #373245;
  }

  &:hover {
    background: #fff;
    color: #373245;
    cursor: pointer;
  }
`;
